/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Form, Button, Icon } from 'semantic-ui-react';
import './PasswordInput.css';

const PasswordInput = ({ ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Extract className and add our custom class
  const { className = '', ...restProps } = props;
  const inputClassName = `password-input-no-reveal ${className}`.trim();

  return (
    <div className="password-input-container">
      <Form.Input
        {...restProps}
        type={showPassword ? "text" : "password"}
        className={inputClassName}
      />
      <Button
        type="button"
        onClick={togglePasswordVisibility}
        className="password-toggle-button"
        tabIndex={-1}
        aria-label={showPassword ? "Hide password" : "Show password"}
      >
        <Icon name={showPassword ? 'eye slash' : 'eye'} />
      </Button>
    </div>
  );
};

export default PasswordInput;
